// -*- Mode: rjsx -*-
import React from 'react';
import moment from 'moment';

export class Spinner extends React.Component {

    constructor(props) {
	super(props);
    }

    render() {
	let style = {
	    text: {
		textAlign: "center",
                fontSize: "140%",
                paddingTop: 20
	    },
	    cubeCenter: {
		margin: "auto",
		top: 25
	    },
            container: {
                padding: 40
            }
	    
	};

	let text = null;
	
	if(this.props.text)
	    text = <div style={style.text}><em>{this.props.text}</em></div>;

	return (
	    <div style={style.container}>
	      <div id="fountainG">
		<div key="fountainG_1" id="fountainG_1" className="fountainG"></div>
		<div key="fountainG_2" id="fountainG_2" className="fountainG"></div>
		<div key="fountainG_3" id="fountainG_3" className="fountainG"></div>
		<div key="fountainG_4" id="fountainG_4" className="fountainG"></div>
		<div key="fountainG_5" id="fountainG_5" className="fountainG"></div>
		<div key="fountainG_6" id="fountainG_6" className="fountainG"></div>
		<div key="fountainG_7" id="fountainG_7" className="fountainG"></div>
		<div key="fountainG_8" id="fountainG_8" className="fountainG"></div>
	      </div>
	      {text}
	    </div>
	);
    }
}


export class SpinnerLarge extends React.Component {

    constructor(props) {
	super(props);
    }

    render() {
	return <img src="/images/gifs/fh-spinner-lg.gif" />;
    }
}
